// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { VideoCameraOutlined } from '@ant-design/icons';

import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import { AssignmentIndOutlined, CastOutlined, EscalatorWarningOutlined } from '@mui/icons-material';
// // icons
const icons = {
  HomeWorkOutlinedIcon,
  VideoCameraOutlined,
  EscalatorWarningOutlined,
  AssignmentIndOutlined,
  CastOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const masters = {
  id: 'group-livestreams',
  title: <FormattedMessage id="livestreams" />,
  icon: icons.HomeWorkOutlinedIcon,
  type: 'group',
  children: [
    {
      id: 'livestream',
      title: <FormattedMessage id="livestream" />,
      type: 'item',
      url: '/livestream',
      icon: icons.VideoCameraOutlined
    },
    {
      id: 'streams',
      title: <FormattedMessage id="streams" />,
      type: 'item',
      url: '/streams',
      icon: icons.CastOutlined
    },
    {
      id: 'parents',
      title: <FormattedMessage id="parents" />,
      type: 'item',
      url: '/parents',
      icon: icons.EscalatorWarningOutlined
    },
    {
      id: 'assignstreams',
      title: <FormattedMessage id="assignstreams" />,
      type: 'item',
      url: '/assignstreams',
      icon: icons.AssignmentIndOutlined
    }
  ]
};

export default masters;
